<template>
  <div class="dhan-auth">
    <!-- Not connected -->
    <div v-if="!isAuthenticated" class="auth-panel">
      <div class="auth-header">
        <div class="auth-icon">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <rect width="48" height="48" rx="12" fill="#0066FF"/>
            <text x="50%" y="54%" dominant-baseline="middle" text-anchor="middle" font-family="Arial, sans-serif" font-weight="700" font-size="18" fill="#fff">DH</text>
          </svg>
        </div>
        <div class="auth-title">
          <h3>Connect DhanHQ</h3>
          <p class="auth-subtitle">Access NSE, BSE, MCX & F&O data with real-time feeds</p>
        </div>
      </div>

      <div class="auth-features">
        <div class="feature-item">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"/>
          </svg>
          <span>Real-time market data via WebSocket</span>
        </div>
        <div class="feature-item">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"/>
          </svg>
          <span>NSE, BSE, MCX & F&O segments</span>
        </div>
        <div class="feature-item">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"/>
          </svg>
          <span>Free API access with Dhan account</span>
        </div>
      </div>

      <div class="auth-button-group">
        <button
          @click="connectDhan"
          :disabled="isLoading"
          class="auth-button"
        >
          <span v-if="isLoading" class="btn-loading">Connecting to DhanHQ...</span>
          <span v-else>Connect with DhanHQ</span>
        </button>
      </div>

      <div v-if="error" class="error-message">
        <span>{{ error }}</span>
      </div>
    </div>

    <!-- Connected -->
    <div v-else class="auth-success">
      <div class="success-header">
        <h3>DhanHQ Connected</h3>
        <p>Your account is linked and receiving data</p>
      </div>
      <div class="auth-actions">
        <button @click="connectDhan" class="auth-button reconnect-action" :disabled="isLoading">Reconnect</button>
        <button @click="disconnect" class="disconnect-button">Disconnect</button>
      </div>
    </div>
  </div>
</template>

<script>
import DhanService from '../services/dhan_service.js';
import DataProviderManager from '../services/data_provider_manager.js';

export default {
  name: 'DhanAuth',
  data() {
    return {
      isLoading: false,
      error: null,
      isAuthenticated: false,
    };
  },
  async mounted() {
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      this.isAuthenticated = DhanService.isAuthenticated();
      if (!this.isAuthenticated) {
        DhanService.restoreSessionFromServer().then(restored => {
          if (restored) this.isAuthenticated = true;
        }).catch(() => {});
      }
    },

    async connectDhan() {
      this.isLoading = true;
      this.error = null;

      try {
        const result = await DhanService.connect();
        this.isAuthenticated = true;
        DataProviderManager.switchProvider('dhan');
        this.$emit('authenticated', result);
        DhanService.loadSymbolMaster().catch(() => {});
      } catch (error) {
        this.error = error.response?.data?.error || error.message || 'Failed to connect to DhanHQ';
      } finally {
        this.isLoading = false;
      }
    },

    disconnect() {
      DhanService.disconnectFromServer();
      this.isAuthenticated = false;
      DataProviderManager.switchProvider('binance');
      this.$emit('disconnected');
    },
  }
};
</script>

<style scoped>
@import './broker-auth-shared.css';
</style>
